import Icon from '../../../components/AppIcon';
import type { TimelineMilestone } from '../types';

interface TimelineSectionProps {
  milestones: TimelineMilestone[];
}

const TimelineSection = ({ milestones }: TimelineSectionProps) => {
  return (
    <section id="results" className="py-20 sm:py-32 bg-background">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Ваш путь к идеальным отношениям
          </h2>
          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Средний пользователь находит совместимого партнёра за 3 месяца
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-accent to-success" />

            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div key={milestone.id} className="relative flex gap-8">
                  <div className="flex-shrink-0 w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-lg shadow-lg z-10">
                    {milestone.week}н
                  </div>

                  <div className="flex-1 bg-card rounded-2xl p-8 border border-border hover:border-primary transition-all duration-300 hover:shadow-xl">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <Icon name={milestone.icon as any} size={24} color="var(--color-primary)" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-foreground mb-2">{milestone.title}</h3>
                        <p className="text-secondary leading-relaxed">{milestone.description}</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 text-sm text-primary font-medium">
                      <Icon name="TrendingUp" size={16} />
                      <span>Неделя {milestone.week}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {[
            { value: '94%', label: 'Точность совпадений', icon: 'Target' },
            { value: '3 мес', label: 'Средний срок до встречи', icon: 'Calendar' },
            { value: '500+', label: 'Успешных пар', icon: 'Heart' }
          ].map((stat, index) => (
            <div key={index} className="bg-card rounded-xl p-6 border border-border text-center">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-success/10 mx-auto mb-4">
                <Icon name={stat.icon as any} size={24} color="var(--color-success)" />
              </div>
              <div className="text-3xl font-bold text-success mb-2">{stat.value}</div>
              <div className="text-sm text-secondary">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;